let studioGroupMain = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;
    /**
* 获取所有消息
* @param {any} success
* @param {any} error
*/
    this.GetStudioGroupListData = function (success, error) {
      var url = ServiceBaseAddress + '/api/StudioGroup/GetStudioGroupList';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }

          }, error);
  }
  this.GetOrgStudioGroupList = function (organizationId, success, error) {
    var url = ServiceBaseAddress + '/api/StudioGroup/GetOrgStudioGroupList/' + organizationId;
    TokenClient.Get(url, true, null, null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }

      }, error);
  }
    this.GetStudioGroupUserData = function (id,success, error) {
      var url = ServiceBaseAddress + `/api/StudioGroup/GetStudioGroupUser/${id}`;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }

            }, error);
    }
    this.GetDistributorPages = function (orgId,keyWord,success, error) {
      var url = ServiceBaseAddress + `/api/Distributor/OrganizationDistributorPages/%20/%20/${orgId}/1/1/${keyWord}/0/0/0/false/0`;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }

            }, error);
    }
    this.AddSubmitStudioGroup = function (item, success, error) {
      var url = ServiceBaseAddress + "/api/StudioGroup/SubmitStudioGroup"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
  }
  this.AddSubmitStudioChildGroup = function (oranizationId, item, success, error) {
    var url = ServiceBaseAddress + "/api/StudioGroup/SubmitStudioChildGroup/" + oranizationId
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
    this.SetStudioGroupUser = function (item, success, error) {
      var url = ServiceBaseAddress + "/api/StudioGroup/SetStudioGroupUser"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
  }
  this.DeleteStudioGroupData = function (id, success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/DeleteStudioGroup/${id}`
        TokenClient.Post(
          url,
          true,
          null,
          null,
          function (data) {
            if (success) {
              var jsonObj = JSON.parse(data)
              success(jsonObj)
            }
          },
          error
        )
    }
    this.DeleteStudioGroupUserData = function (id, success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/DeleteStudioGroupUser/${id}`
        TokenClient.Post(
          url,
          true,
          null,
          null,
          function (data) {
            if (success) {
              var jsonObj = JSON.parse(data)
              success(jsonObj)
            }
          },
          error
        )
    }
    this.SetStudioGroupEnabledData = function (id, success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/SetStudioGroupEnabled/${id}`
        TokenClient.Post(
          url,
          true,
          null,
          null,
          function (data) {
            if (success) {
              var jsonObj = JSON.parse(data)
              success(jsonObj)
            }
          },
          error
        )
    }
    this.SetStudioUserInheritData = function (id, success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/SetStudioUserInherit/${id}`
        TokenClient.Post(
          url,
          true,
          null,
          null,
          function (data) {
            if (success) {
              var jsonObj = JSON.parse(data)
              success(jsonObj)
            }
          },
          error
        )
    }
    
}


export { studioGroupMain }
